<template>
	<b-col class="text-center">
		<div v-animate-onscroll="animateClass" class="contact-item">
			<FAIcon :icon="itemData.icon" />
			<h3 v-if="itemData.name" class="h6">{{ itemData.name }}</h3>
			<p v-if="itemData.channel && itemData.isEmail" class="text-muted">
				<a
					href=""
					class="crypted"
					:data-name="itemData.channel[0]"
					:data-domain="itemData.channel[1]"
					:data-tld="itemData.channel[2]"
					@click.prevent="emailMe"
				></a>
			</p>
			<p v-else-if="itemData.channel">{{ itemData.channel }}</p>
		</div>
	</b-col>
</template>

<script>
export default {
	name: 'ContactItem',

	props: {
		itemData: {
			type: Object,
			required: true
		}
	},

	computed: {
		animateClass() {
			let animateClass = 'animate__animated '

			if (this.itemData.isFirst) {
				animateClass += 'animate__fadeInLeft'
			} else if (this.itemData.isLast) {
				animateClass += 'animate__fadeInRight'
			} else {
				animateClass += 'animate__fadeInUp'
			}

			return animateClass
		}
	},

	methods: {
		emailMe() {
			window.location.href =
				'mailto:' +
				this.itemData.channel[0] +
				'@' +
				this.itemData.channel[1] +
				'.' +
				this.itemData.channel[2] +
				'?subject=Contacto%20Web'
			return false
		}
	}
}
</script>
